"use strict";
function interopDefault(mod) {
  return mod.default || mod;
}

export { interopDefault };
